<app-navbar></app-navbar>


<div class="affaires">
  <div class="header">
    <div class="spinner-container">
      <mat-progress-spinner
        *ngIf="isLoading"
        mode="indeterminate"
        diameter="30"
        class="spinner">
      </mat-progress-spinner>
      <h1>Clients :</h1>
      <h2>{{ dataSource.data.length }} client(s) trouvé(s)</h2>
    </div>
    <div>
      <div class="inputs-contenair">
        <input [(ngModel)]="searchString" (ngModelChange)="updateSearchString($event)" placeholder="Recherche par nom..." />
      </div>
    </div>
  </div>
  <div>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nom Client</th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let row">{{ row.created_at | date}}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Lien PowerBI</th>
          <td mat-cell *matCellDef="let row">
            <a target="_blank" [href]="row.powerbi_link">
            ...{{ row.powerbi_link.slice(row.powerbi_link.length - 20, row.powerbi_link.length)}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef>Editer</th>
          <td mat-cell *matCellDef="let row">
            <button (click)="openAddClientDialog(row.id_nrj, row.powerbi_link)">Editer</button>
          </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
